import { User, UserRole } from "../../types";
import ApiModule from "../base";

export type UserParams = Omit<Omit<User, "role">, "activated">;

export default class RegistrationsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "auth/registrations");
  }

  async create(
    user: UserParams,
  ): Promise<{ jwtToken: string; role: UserRole }> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify(user),
    });
    return await this._resolve(request);
  }
}
